import React, { Component } from "react";
import Image from '../global/Image';

export default class PageImage extends Component {
  	
	render() {
		
		const block = this.props.block; 
		
		let blockClass = 'c-page__block c-page__block--load-effect';
			
		if (block.rule === true) {
			blockClass = blockClass + ' c-page__block--border-bottom';	
		}
		
		if (block.space_after === 'small') {
			blockClass = blockClass + ' c-page__block--small-space';	
		} else if (block.space_after === 'text') {
			blockClass = blockClass + ' c-page__block--text-space';	
		} else if (block.space_after === 'margin') {
			blockClass = blockClass + ' c-page__block--margin-space';	
		}
		
		let gridClass = 'l-grid__col';
		if (block.size === 'right') {
			gridClass = 'l-grid__col l-grid__col--m-8-12 l-grid__col--m-push-4-12';
		}
			
		return (
			
			<div id={block.id} className={blockClass}>
			
				<div className="l-grid">
				
					<div className={gridClass}>
						
						{block.src &&
																
							<Image width={block.width} height={block.height} srcset={block.srcset} src={block.src} />
																				
						}
						
					</div>
				
				</div>
				
			</div>
			
		)
		
	}
							
}